<!--=============================
=            WINDOWS            =
==============================-->

<template>
  <!-- WIDGETS CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Windows</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <!-- WIDGETS  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <div class="pa-5">
              <Playground-group></Playground-group>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Vertical</div>
          <div slot="card-body">
            <div class="pa-5">
              <vertical-group></vertical-group>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Reverse</div>
          <div slot="card-body">
            <div class="pa-5">
              <reverse-group></reverse-group>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Onboarding</div>
          <div slot="card-body">
            <div class="pa-5">
              <onboarding-group></onboarding-group>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Account creation</div>
          <div slot="card-body">
            <div class="pa-5">
              <account-creation></account-creation>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import PlaygroundGroup from "../../components/Groups/Windows/PlaygroundGroup.vue";
import VerticalGroup from "../../components/Groups/Windows/VerticalGroup.vue";
import ReverseGroup from "../../components/Groups/Windows/ReverseGroup.vue";
import OnboardingGroup from "../../components/Groups/Windows/OnboardingGroup.vue";
import AccountCreation from "../../components/Groups/Windows/AccountCreation.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    PlaygroundGroup,
    VerticalGroup,
    ReverseGroup,
    OnboardingGroup,
    AccountCreation
  },
  data: () => ({
    length: 3,
    window: 0,
    showArrows: false,
    vertical: false,
    reverse: false,
    autorun: false
  }),

  created() {
    setInterval(() => {
      if (!this.autorun) return;
      if (++this.window >= this.length) this.window = 0;
    }, 1000);
  }
};
</script>

<!--====  End of WINDOWS  ====-->
